import { TextSubtextRendererValue } from "@src/types/custom_renderer_types";
import { CustomCellRendererProps } from "ag-grid-react";
import "./text_subtext_renderer.less";

interface TextSubtextRendererProps {
  props: CustomCellRendererProps;
  variant?: null | "small-blue";
}

const TextSubtextRenderer: React.FC<TextSubtextRendererProps> = ({
  props,
  variant = null,
}) => {
  const { text, subtext }: TextSubtextRendererValue = props.value;

  const classes = variant
    ? `text-subtext-renderer text-subtext-renderer--${variant}`
    : "text-subtext-renderer";

  return (
    <div className={classes}>
      <div className="text-subtext-renderer__text">{text}</div>
      <div className="text-subtext-renderer__subtext">{subtext}</div>
    </div>
  );
};

export default TextSubtextRenderer;
